export const getBadgeByIds = (state, badgeIds) => state.badges.find((b) => badgeIds.includes(b.id));
